import { useEffect } from "react";

import { useAtomValue } from "jotai";

import { sessionStatusAtom } from "../atoms";
import { refreshSession } from "../refresh";

const FOURTEEN_MINUTES = 14 * 60 * 1000;

/**
 * Background refresh — proactively rotates the access token before its 15min
 * lifetime expires. Mount once near the app root, inside the auth provider.
 *
 * Pauses when status is unauthenticated; resumes when authenticated.
 */
export function useRefreshToken(intervalMs: number = FOURTEEN_MINUTES): void {
  const status = useAtomValue(sessionStatusAtom);

  useEffect(() => {
    if (status !== "authenticated") return;
    const id = setInterval(() => {
      // Background tick — swallow transient failures (network/5xx).
      // refreshSession now throws on non-401 errors; without this catch we
      // emit unhandled promise rejections. The next tick (or a focus
      // refetch) will retry on its own.
      refreshSession().catch(() => {});
    }, intervalMs);
    return () => clearInterval(id);
  }, [status, intervalMs]);
}
